<template>
  <div id="content" class="linkplusGenerator">


    <div class="container">
      <div class="messagepromopubContainerBandeau">
        <div class="messagepromopub">
          Broaden innovation reach
          <a href="https://outlook.office365.com/book/innopearl@innopearl.ch/" target="_blank" class="bluehover"><strong>Leverage our scouting expertise</strong></a>
        </div>
      </div>
            <div class="linkplusContent">

      <div class="row">
              <div class="col-12 col-lg-6 col-xl-4 mt20">
                <div class="zone_input ">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Linked to a project</span>
                  </div>
                  <div class="custom-toggle mt20">
                     <button
                       :class="{'active': myLinkPlus.linked_to_project == true}"
                       @click="myLinkPlus.linked_to_project = true;"
                     >
                       Yes
                     </button>
                     <button
                       :class="{'active': myLinkPlus.linked_to_project != true}"
                       @click="myLinkPlus.linked_to_project = false;myLinkPlus.project = null;"
                     >
                       No
                     </button>
                   </div>
                </div>
                <div class="zone_input mt20" v-if="myLinkPlus.linked_to_project">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Choose the project</span>
                  </div>
                  <select class="innopearl_input"  v-model="myLinkPlus.project" @change="maybeSetName($event)" >
                    <option value="null" disabled>Choose a project</option>
                    <option v-for="(project, p ) in projects " :key="p" :value="project._id">{{project.name}}</option>
                  </select>
                </div>

                <div class="zone_input mt20">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Campaign name</span>
                  </div>
                  <input type="text" maxlength="30" class="innopearl_input" v-model="myLinkPlus.name" placeholder="Please name your campaign">
                </div>
                <div class="zone_input mt20">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Open to</span>
                  </div>
                  <div class="custom-toggle mt20">
                     <button
                       :class="{'active': myLinkPlus.open_to === 'startups'}"
                       @click="myLinkPlus.open_to = 'startups'"
                     >
                       Only startups
                     </button>
                     <button
                       :class="{'active': myLinkPlus.open_to === 'other'}"
                       @click="myLinkPlus.open_to = 'other'"
                     >
                       Any organization
                     </button>
                   </div>
                </div>
                <div class="zone_input mt20">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Image banner</span>
                  </div>
                  <small>Recommended size: 1600x500 px</small>
                  <div class="mylink_banner" >
                     <img :src="this.apiUrl+'/get_image/'+smyLinkPlus_image+'?token='+$store.state.innotoken" alt="" class="forceSize" v-if="myLinkPlus.image">
                     <div class="changeImage">
                        <button type="button" name="button" @click='dialog.image = true'>+ CHANGE IMAGE</button>
                        <ImageChange :dialogVisible='dialog.image' @close="dialog.image=false" @newValueIsProposed="imageChangeVal($event)" ></ImageChange>
                    </div>
                  </div>
                </div>


                                  <div class="zone_input mt20">
                                        <div class="zone_input_header">
                                            <span class="zone_input_name ">Application's expiration date</span>
                                        </div>
                                          <input type="date" ref="dateInput" autocomplete="off" placeholder="dd-mm-yyyy"  :class="hasValue ? 'innopearl_input' : 'innopearl_input noValue'" v-model="myLinkPlus.expirationDate">
                                  </div>

              </div>

              <div class="col-12 col-lg-6 col-xl-8 mt20">
                <div class="zone_input">
                      <div class="zone_input_header">
                        <div class="">
                            <span class="zone_input_name">Description</span>
                        </div>

                          <div class="flexbtnheader">
                            <button type="button" class="fillit" name="button" @click="fillWithTemplate">Apply template</button>

                            <button type="button" class="fillit" name="button" v-if="myLinkPlus.project?.$oid" @click="fillFromProject">Fill from project</button>

                          </div>

                      </div>
                      <small style='width:100%;display:block;margin-top:10px;'>Share your needs and attract innovators, or apply the template set up by your admin</small>

                      <div class="mt20">
                        <QuillEditor ref="linkplusContentEditor"  theme="snow" v-model="content" :content="content" contentType="html" :toolbar="toolbarOptions" />

                      </div>
                </div>
                <div class="zone_input mt50">
                      <div class="zone_input_header">
                          <span class="zone_input_name">Terms and conditions</span>
                      </div>
                      <small>Show the Terms and Conditions that apply to applicant participation on your landing page</small>
                      <div class="mt20">
                        <label for="disableFeedBackCheckbox" class="selectIt forceWidth300" >
                          <input class="customizeCheckbox" type="checkbox" v-model="myLinkPlus.show_terms" id="disableFeedBackCheckbox" >
                          <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>
                          <span>{{ $t("Show the Terms and Conditions")}}</span>
                        </label>
                      </div>

                      <div class="mt20" v-if="myLinkPlus.show_terms">
                        <textarea name="name" rows="8" cols="80" v-model="myLinkPlus.terms_and_conditions" placeholder="Terms and Conditions are managed and set by your team’s administrator. Please reach out to your admin for more details or updates"></textarea>

                      </div>
                </div>

              </div>

              </div>
              <div class="row mt20 ">
                <div class="text-right">
                  <button type="button" class="btn next_step_btn" name="button" @click="generateLinkplus">Create my landing page</button>

                </div>
            </div>
            <div class="row text-center ither_potential">
              Use Link+ to engage innovators at events, through your network, or on your website. Just add it to your phone and scouting campaigns—or share it with colleagues.
            </div>
            </div>

    </div>

  </div>
</template>
<script>
 // import AddCommentModal from '@/components/modals/addComment.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   // import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
import { toast } from 'vue-sonner'
import api from '../tools/api';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import ImageChange from '@/components/modals/imageChange.vue'
import Quill from 'quill';

// Add fonts to whitelist
const Font = Quill.import('formats/font');
Font.whitelist = ['OpenSans', 'Roboto', 'Lato', 'Montserrat', 'SourceSansPro', 'Poppins', 'Raleway', 'Ubuntu', 'Oswald',"Merriweather"];
Quill.register(Font, true);


export default {
  components: {
    QuillEditor,
    ImageChange,

    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      pageInfo: {
        mainTitle : "My Link+ space",
        subTitle : "Generate your scouting campaigns",
      },
      project:null,
      projects:[],
      dialog:{
        image:false,
      },
      toolbarOptions : [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
        [{ 'header': [1, 2, 3, false] }],
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': Font.whitelist }],
        ['clean']                                         // remove formatting button
      ],
      contentHTML:"",
      content:"",
      myLinkPlus_template: "",
      myLinkPlus : {
        name: "",
        link : null,
        image:null,
        qrcode : null,
        content: '',
        status : "DRAFT",
        expirationDate: '',
        open_to : 'startups',
        show_terms : true,
        project:null,
      }
    }
  },
  methods:{
    fillWithTemplate(){
      this.$refs.linkplusContentEditor.setHTML(this.myLinkPlus_template);


    },
    fillFromProject(){
      if(this.myLinkPlus.project.$oid){
        const foundItem = this.projects.find(item => item._id.$oid == this.myLinkPlus.project.$oid);
        console.log(foundItem);
        api.get(process.env.VUE_APP_API_URL+"/restrict/linkplus_desc_from_p/"+this.myLinkPlus.project.$oid,{
            headers: {
                'Content-Type': 'application/json',
            }
        }).then( (r) => {
          console.log(r.data);
                  this.$refs.linkplusContentEditor.setHTML(r.data);
        });


      }
    },
    maybeSetName(){
      if(this.myLinkPlus.project.$oid){
        const foundItem = this.projects.find(item => item._id.$oid == this.myLinkPlus.project.$oid);
        console.log(foundItem);
        this.myLinkPlus.name = foundItem.name;
      }

    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    imageChangeVal(val){
      console.log(val);
      if(val){
        this.myLinkPlus.image = val;
        this.dialog.image = false;
      }
    },
    isValid(){
      var valid = true;

      if(!this.myLinkPlus.name){
        valid =false;
        toast.error('Campaign name is required');
      }
      if(!this.myLinkPlus.image){
        valid =false;
        toast.error('Image is required');
      }
      if(this.myLinkPlus.expirationDate){
        if(new Date(this.myLinkPlus.expirationDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)){
          valid = false;
          toast.error("Expiration date must be in the future");
        }
      }
      return valid;

    },
    generateLinkplus(){
      //var validator = ‹this.isValid()›
      if(this.isValid()){
          this.myLinkPlus.contenthtml = this.$refs.linkplusContentEditor.getHTML();
          api.post(process.env.VUE_APP_API_URL+"/restrict/create_linkplus_v2",this.myLinkPlus,{
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then( (r) => {
            console.log(r);

            this.myLinkPlus._id = r.data;
            this.$store.commit('UPDATE_LINKSPLUS',this.myLinkPlus)
            toast.success("Your Link+ has been successfully generated.");
            setTimeout(() => {
          window.location = '/manage_link_plus/'+r.data.$oid;
        }, "1000");


          }).catch( () => {
            toast.error("Error during generation. Please try again.");
          });
      }else{
        // toast.error("Please check your inputs");
      }
    },


  },
  computed:{
    smyLinkPlus_image: function(){
      if(this.myLinkPlus.image){
        console.log(this.myLinkPlus.image);
        return this.myLinkPlus.image.$oid;
      }
      else{
        return null;
      }

    },
    hasValue() {
      return (this.myLinkPlus.expirationDate !== '' && this.myLinkPlus.expirationDate != null);
    }

  },

  mounted(){
    api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
      this.projects = r.data;
      //this.projects.unshift({_id:null,name:'No link to project'});
      console.log(r.data);
      console.log(r);
    }).catch( (e) => console.log(e));
    //if route params then load content
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
    api.get(process.env.VUE_APP_API_URL+"/restrict/company_info_v2").then( (r) => {
      // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
      // console.log();
      // var temp = _.merge(this.candidatespool, r.data)
      console.log(r.data);
      this.userInfo = r.data;
      console.log("USERINFO");
      console.log(this.userInfo);
      if(this.userInfo.about_company){
        this.myLinkPlus_template ='<h3><strong>Company</strong></h3><p></p><p><span class="ql-font-Montserrat">'+this.userInfo.about_company+'</span></p><br><h3><strong style="color: rgb(187, 187, 187);">Challenge</strong></h3><p style="color: rgb(187, 187, 187);"></p><p><span class="ql-font-Montserrat" style="color: rgb(187, 187, 187);">Provide a description of your needs</span></p><br/><h3><strong style="color: rgb(187, 187, 187);">How it works </strong></h3><p style="color: rgb(187, 187, 187);"></p><p><span class="ql-font-Montserrat" style="color: rgb(187, 187, 187);">Provide a description of the selection process</span></p>';
      }
      else{
        this.myLinkPlus_template ='<h3><strong>Company</strong></h3><p></p><p><span class="ql-font-Montserrat">A short description of your company and team.</span></p><br><h3><strong style="color: rgb(187, 187, 187);">Challenge</strong></h3><p style="color: rgb(187, 187, 187);"></p><p><span class="ql-font-Montserrat" style="color: rgb(187, 187, 187);">Provide a description of your needs</span></p><br/><h3><strong style="color: rgb(187, 187, 187);">How it works </strong></h3><p style="color: rgb(187, 187, 187);"></p><p><span class="ql-font-Montserrat" style="color: rgb(187, 187, 187);">Provide a description of the selection process</span></p>';

      }
      if(this.userInfo.banner){
        this.myLinkPlus.image = this.userInfo.banner;
      }

      if(this.$route.query?.lpname){
        this.myLinkPlus.name = decodeURIComponent(this.$route.query.lpname);
      }
      if(this.$route.query?.src == "pearlai"){
        this.myLinkPlus_template = '<p><strong style="color: black;">ABOUT THE PARTNERSHIP OPPORTUNITY </strong></p><p>'+this.$route.query.problem_to_be_solved+'</p><p><strong>&nbsp;</strong></p><br/><p><strong style="color: black;">INNOVATIONS WE ARE LOOKING FOR </strong></p><p><span style="color: black;">We are interested in innovations in ';
        if(this.$route.query?.recommended_technologies){
          console.log(this.$route.query.recommended_technologies);
          var reco = JSON.parse(decodeURIComponent(this.$route.query.recommended_technologies));
          var iii = 0;
          if(typeof reco == 'string') reco = [reco];
          reco.forEach((item) => {
            if(iii != 0) this.myLinkPlus_template +=", ";
            iii++;
            this.myLinkPlus_template += item;
          });

        }
        this.myLinkPlus_template += 'and offering the following benefits:</span></p><br/><ul>';
        console.log(this.$route.query);
        if(this.$route.query?.benefits_for_the_end_customers){

          var benef = JSON.parse(decodeURIComponent(this.$route.query.benefits_for_the_end_customers));
          if(typeof benef == 'string') benef = [benef];
          benef.forEach((item) => {
            this.myLinkPlus_template += "<li>"+item+"</li>";
          });

        }
        this.myLinkPlus_template +='</ul><br/><br/><p><strong> WHAT WE OFFER TO SELECTED PARTNERS </strong></p><br/><ul><li></li><li></li><li></li></ul><br/><br/><p><strong>INTERESTED?</strong></strong></p><p>Tell us more your your company and your solutions before the application deadline.</p><br/><p>Our team will review all submissions and reach out to selected companies for an initial meeting.</p><p>Not selected for this challenge?</p><br/><p>You’ll still gain visibility within our organization, and if your solution matches a future business need, we may contact you.</p><br/><p>We’re excited to learn about what you’re building and look forward to connecting soon!</p>';
      }
      this.$refs.linkplusContentEditor.setHTML(this.myLinkPlus_template);
      this.myLinkPlus.terms_and_conditions = this.userInfo.terms_and_conditions ?? "";

    }).catch( (e) => {
      console.log(e);


       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     });


   },

}
</script>
<style scoped>
.toggle-wrapper {
  margin: 20px 0;
}

.toggle-label {
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
}

.required {
  color: red;
}

.custom-toggle {
  display: flex;
  border: 1px solid #1368b2;
  border-radius: 999px;
  overflow: hidden;
  width: fit-content;
}

.custom-toggle button {
  background: transparent;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  color: #1368b2;
  transition: background 0.3s;
}

.custom-toggle button.active {
  background-color: #1368b2;
  color: #fff;
}
.text-center{
  text-align:center;
}
.ither_potential{
    text-transform:none;
    color: #0b1f72;
    font-size:18px;
    display:block;
    margin-top:40px;
}
.messagepromopubContainerBandeau{
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 0px;
  text-align: center;
  background: #1368b2;
  color: #FFF;
  padding: 12px;
}
.messagepromopubContainerBandeau a:hover{
  color:inherit !important;
}
.linkplusGenerator{
  padding-top:50px;
  padding-bottom: 50px;
}
.linkplusContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-bottom: 50px;

}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}


.zone_input_icon{
  width: 55px;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
}
.mt20{
  margin-top: 20px;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
margin-top:20px;
height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}
textarea{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: calc(100%);
margin-bottom: 20px;
padding: 5px;
 resize: none;
}

.changeImage{
  position:absolute;
  top:15px;
  right:30px;
  font-size:12px;
  color:#FFF;
  background: #3783C5;
  border-radius:200px;
  padding:5px 10px;

}
.mylink_banner{
  margin-top: 20px;
  position:relative;
  height:300px;
  background:#EFEFEF;
  padding: 0 !important;
}
.mylink_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.tblack{
  color:#000;
}

.fillit{
    border:1px solid #3783C5;
    color:#3783C5;
    background:#FFF;
    padding:5px 10px;
    font-size:12px;
    line-height: 15px;
    margin-left:10px;
    align-self: center;
    margin-left: auto;
    border-radius: 50px;

}



@supports (font: -apple-system-body) and (-webkit-appearance:none){
  input[type="date"].noValue{
    color: #000;
    position:relative;
  }
  input[type="date"].noValue:before{
    content :'dd/mm/YYYY';
    color:#333;
    display:inline-block;
    position:absolute;
  }
 input[type="date"].noValue::-webkit-datetime-edit {
    visibility: hidden;
  }
}


.messagepromopubContainer{
  display:flex;
  justify-content: flex-end;
  width:100%;
  margin-bottom:10px;
  text-align:center;
}
@media screen and (max-width:990px){
  .messagepromopubContainer{
    display:flex;
    justify-content: center;
      margin-bottom:20px;
  }
}
    .bluehover{
      color:inherit;
    }
    .bluehover:hover{
      color:#3783C5;
    }


    .selectIt{


    display:flex;
    align-items: center;
    gap: 5px;
    }
      input[type="checkbox"].customizeCheckbox{
        display:none;
      }
      .custom-checkbox img{
            display:none;
            position: absolute;
      top: 3px;
      left: 3px;
      width:12px;
      }

      .custom-checkbox {
          width: 20px; /* Circle diameter */
          height: 20px; /* Circle diameter */
          border: 2px solid #5081C1; /* Light gray border for unselected state */
          border-radius: 0%; /* Make it a circle */
          transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
      }


      input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox {
          border-color: #5081C1; /* Change border color when selected */
          background:#5081C1;
          position:relative;
      }
      input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox > img{
          display:block;
      }
      .mt50{
        margin-top:50px;
      }

      .flexbtnheader{
        display:flex;
        gap:10px;
        margin-left:auto;
      }
</style>
<style media="screen">
  .ql-editor{
    min-height:300px;
    font-family: 'Montserrat' !important;
  }

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value]::before {
  content: attr(data-value) !important;
}

.ql-snow .ql-picker.ql-font {
  width: 150px !important;
  white-space: nowrap;
}


.ql-snow .ql-picker.ql-font .ql-picker-label[data-value]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value]::before {
  content: attr(data-value) !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Roboto"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Roboto"]::before {
  font-family: 'Roboto' !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="OpenSans"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="OpenSans"]::before {
  font-family: 'Open Sans' !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Lato"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Lato"]::before {
  font-family: 'Lato' !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Montserrat"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Montserrat"]::before {
  font-family: 'Montserrat' !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SourceSansPro"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SourceSansPro"]::before {
  font-family: 'Source Code Pro' !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Poppins"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Poppins"]::before {
  font-family: 'Poppins' !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Raleway"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Raleway"]::before {
  font-family: 'Raleway' !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Ubuntu"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Ubuntu"]::before {
  font-family: 'Ubuntu' !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Oswald"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Oswald"]::before {
  font-family: 'Oswald' !important;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Merriweather"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Merriweather"]::before {
  font-family: 'Merriweather' !important;
}

.ql-font-Oswald{
    font-family: 'Oswald' !important;
}
.ql-font-Merriweather{
    font-family: 'Merriweather' !important;
}
.ql-font-Ubuntu{
      font-family: 'Ubuntu' !important;
}
.ql-font-Raleway{
      font-family: 'Raleway' !important;
}
.ql-font-Poppins{
      font-family: 'Poppins' !important;
}
.ql-font-Montserrat{
      font-family: 'Montserrat' !important;
}
.ql-font-Lato{
      font-family: 'Lato' !important;
}
.ql-font-Oswald{
      font-family: 'Oswald' !important;
}

.ql-font-OpenSans{
      font-family: 'Open Sans' !important;
}

.ql-font-SourceSansPro{
  font-family: 'Source Code Pro' !important;
}
.ql-container{
  font-size:14px !important;
}
</style>
